module.exports = __webpack_public_path__ + "static/img/1057.c1f1c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1057.jpg
// module id = 239
// module chunks = 0